import { Container, Title, Text, SimpleGrid, Paper, ThemeIcon, rem } from '@mantine/core';
import { IconRocket, IconUsers, IconShieldCheckered } from '@tabler/icons-react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const features = [
  {
    icon: <IconRocket size={rem(32)} />,
    title: 'Direct Collaborations',
    description: 'No middlemen. Connect directly with brands, negotiate terms, and get paid on time.',
  },
  {
    icon: <IconUsers size={rem(32)} />,
    title: 'Vetted Community',
    description: 'Join a curated community of serious creators and authentic brands you can trust.',
  },
  {
    icon: <IconShieldCheckered size={rem(32)} />,
    title: 'Secure & Transparent',
    description: 'All transactions are handled securely through our platform with clear, upfront terms.',
  },
];

export function FeatureShowcase() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.5 } },
  };

  return (
    <Container size="lg" ref={ref}>
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
      >
        <Title order={2} ta="center" style={{ fontSize: rem(40), marginBottom: rem(40) }}>
          Why Collabish?
        </Title>
        <SimpleGrid cols={{ base: 1, md: 3 }} spacing="xl">
          {features.map((feature) => (
            <motion.div key={feature.title} variants={itemVariants}>
              <Paper p="xl" radius="lg" shadow="md" withBorder style={{ height: '100%' }}>
                <ThemeIcon size={rem(60)} radius="lg" variant="light" color="primary">
                  {feature.icon}
                </ThemeIcon>
                <Title order={3} mt="lg">
                  {feature.title}
                </Title>
                <Text mt="sm" c="dimmed">
                  {feature.description}
                </Text>
              </Paper>
            </motion.div>
          ))}
        </SimpleGrid>
      </motion.div>
    </Container>
  );
}
